const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M18.78 18.78a.75.75 0 0 0 .17-.263l.048-.22.002-.048V7.997a.751.751 0 0 0-1.503 0v8.439L6.352 5.29A.751.751 0 0 0 5.29 6.353l11.145 11.145H7.997a.751.751 0 0 0 0 1.502h10.254a.75.75 0 0 0 .529-.22"/></svg>';
export {
  a as w
};
